import React, { useState } from "react";

const statDescriptions = {
  Aggressivity: "A high aggressivity makes the bot frequently attack, but also increases its obliviousness. A low aggressivity leads to a more defensive strategy.",
  Techskill: "Higher techskill prioritizes precise techniques like wave-dashing. A lower techskill would result in strategies with less emphasis on advanced movement.",
  Offstage: "A high offstage preference leads the bot to aggressively challenge its opponent’s recovery. A low offstage preference keeps the bot more grounded.",
  Creativity: "A high creativity encourages the bot to explore moves that it uses rarely.",
  Neutral: "A high neutral preference focuses on controlling space. A low neutral preference can lead to a more chaotic playstyle, with the bot frequently losing its position and opportunities.",
  Adaptability: "A high adaptability enables the bot to adjust its strategy based on the opponent's actions. A low adaptability results in a more rigid playstyle.",
  StageControl: "High stage control encourages the bot to maintain advantageous positions on the stage. Low stage control results in more reactive play.",
};

const StatsAllocator = ({ stats, onSliderChange }) => {
  const [focusedStat, setFocusedStat] = useState(null); // Track the focused stat for the description

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {Object.keys(stats).map((stat) => (
        <div
          key={stat}
          className="flex flex-col items-center text-center px-5 py-1 text-gray-200 bg-gray-900/50 rounded-lg"
          onTouchStart={() => setFocusedStat(stat)}
          onMouseEnter={() => setFocusedStat(stat)} // Show description on hover
          onMouseLeave={() => setFocusedStat(null)} // Hide description when hover ends
        >
          <label className="text-sm text-gray-200">{stat}</label>
          <input
            type="range"
            min="0"
            max="100"
            value={stats[stat]}
            onChange={(e) => onSliderChange(stat, e.target.value)}
            className="slider rounded-lg appearance-none w-full h-1 bg-blue-950 rounded-lg mt-3 cursor-pointer"
          />
          <span className="text-xs text-gray-400 mt-3">{stats[stat]} pts</span>
        </div>
      ))}

      {/* For the last 2 grid items on the last row, add extra space for descriptions */}
      
      <div className="col-span-2 flex justify-center">
        {focusedStat && (
        <div className="bg-gray-800/50 text-white text-xs p-1 rounded-lg shadow-md w-80">
          {statDescriptions[focusedStat]}
        </div>
        )}
      </div>

      {/* Warning text below sliders */}
      <div className="col-span-3 text-center mt-4 text-sm text-yellow-400 italic">
        <p>Note: Tuning these settings can be tricky, and maxing out all values may lead to poor strategies. While the described effects are expected, the actual strategy will depend on the chosen balance. Aim for the right mix between each component.</p>
      </div>
    </div>
  );
};

export default StatsAllocator;
